/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { /*OverlayTrigger, Tooltip,*/ Badge } from "react-bootstrap";
import { useSelector } from "react-redux";

import { Notifications } from "@mui/icons-material";

import clsx from "clsx";

const NotificationListToggler = ({ toggleBy = "kt_notification_list_toggler_btn" }) => {
  // Redux selectors using useSelector hook
  const unreadCount = useSelector((store) => store.notifications.unreadCount);

  return (
    <div
      className="kt-header__topbar-item kt-header__topbar-item--quick-panel"
      data-toggle="kt-tooltip"
      title="Notifications"
      data-placement="right"
    >
      <span className="kt-header__topbar-icon" id={toggleBy}>
        <h6
          className={`${clsx({
            "d-none": !unreadCount || unreadCount <= 0,
          })}`}
        >
          <Badge className="unread-count" variant="primary" pill>
            {unreadCount}
          </Badge>
        </h6>

        <Notifications fontSize="inherit" />
      </span>
    </div>
  );
};

export default NotificationListToggler;
